// Stockage local uniquement (IndexedDB) : aucune donnée ne quitte l'appareil.
const DB = "m2hat_local", STORE = "questionnaire_session";

const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => { if (!r.result.objectStoreNames.contains(STORE)) r.result.createObjectStore(STORE, { keyPath: "session_id" }); };
  r.onsuccess = () => res(r.result);
  r.onerror = () => rej(r.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => { db.close(); res(req && req.result); };
    t.onerror = () => { db.close(); rej(t.error); };
  });
};

export const localGet = (id) => tx("readonly", (s) => s.get(id)).catch(() => null);
export const localPut = (doc) => tx("readwrite", (s) => s.put(doc)).catch(() => null);
export const localDelete = (id) => tx("readwrite", (s) => s.delete(id)).catch(() => null);
